<template>
	<el-dialog title="关联直播" :visible.sync="dialogVisible" width="600px">
		<el-table :data="activityList" stripe style="width: 100%">
			<el-table-column prop="id" label="直播间ID" width="100" align="center" />
			<el-table-column label="直播间头图" width="120" align="center">
				<template slot-scope="scope">
					<img :src="scope.row.bannerUrl+'!banner'" alt="头图" style="width: 110px; height: 60px; object-fit: cover" />
				</template>
			</el-table-column>
			<el-table-column prop="title" label="直播间名称" align="center">
                <template slot-scope="scope">
                    <el-link @click="goActivity(scope.row.id)">{{ scope.row.title }}</el-link>
				</template>
            </el-table-column>
		</el-table>
		<el-pagination
			@current-change="handlePageChange"
			:current-page="pagination.pageNum"
			:page-size="pagination.pageSize"
			:total="pagination.total"
			layout="prev, pager, next"
		/>
		<!-- <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span> -->
	</el-dialog>
</template>

<script>
import { jobRecruit } from "@/services";

export default {
	name: "ActivitySelectDialog",
	props: {
		value: Boolean,
		jobId: Number,
	},
	data() {
		return {
			activityList: [],
			pagination: {
				pageNum: 1,
				pageSize: 10,
				total: 0,
			},
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	watch: {
		value(val) {
			if (val && this.jobId) {
				this.fetchActivities();
			}
		},
	},
	methods: {
        goActivity(id) {
			let uri = `/admin/#/mylive/video/${id}`;
			window.open(uri, '_blank');
		},
		fetchActivities() {
			const params = {
				pageNum: this.pagination.pageNum,
				pageSize: this.pagination.pageSize,
			};
			jobRecruit
				.activityList(this.jobId, params)
				.then(({data, ok}) => {
                    if(ok) {
                        this.activityList = data.data.list || [];
					    this.pagination.total = data.data.total || 0;
                    }
 					
				})
				.catch((err) => {
					console.error("获取直播间列表失败", err);
				});
		},
		handlePageChange(page) {
			this.pagination.pageNum = page;
			this.fetchActivities();
		},
		cancel() {
			this.dialogVisible = false;
		},
		confirm() {
			// 这里可以添加关联逻辑
			this.$emit("confirm");
			this.dialogVisible = false;
		},
	},
};
</script>

<style scoped></style>
